import { Component, OnInit } from '@angular/core';
import { switchMap, take, tap, withLatestFrom } from 'rxjs/operators';

import { UserService } from '@core/services/user/user.service';
import { AuthFirebaseService } from '@core/services/api/auth-firebase/auth-firebase.service';
import { UserCredential } from 'firebase/auth';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { of } from 'rxjs';

@Component({
  template: ``,
  selector: 'app-anonymous-authentication-preloader-block',
})
export class AnonymousAuthenticationPreloaderBlockComponent implements OnInit {
  constructor(
    private readonly authFirebaseService: AuthFirebaseService,
    private readonly userService: UserService,
    private readonly authStoreSelector: AuthStoreSelector,
  ) {}

  ngOnInit(): void {
    this.authFirebaseService
      .isAuthenticate$()
      .pipe(
        withLatestFrom(
          this.authStoreSelector.selectUserIsLoaded,
          this.authStoreSelector.selectUserIsLoading,
        ),
        take(1),
        switchMap(([isAuthenticated, isUserLoaded, isUserLoading]) => {
          // If it happen that the user is not authenticated to firebase, but not retrieved from the backend.
          // eg: If the createAnonymous user api request failed, and if the page is reloaded (because an error popup will display a reload button),
          // The user will be authenticated to firebase, but not loaded in store Authentication store (that leads to impossible access to the cart).
          const mustCrateAnonymousUser = !isAuthenticated || (!isUserLoaded && !isUserLoading);
          if (!mustCrateAnonymousUser) {
            console.log('[AnonymousAuthenticationPreloader] User already authenticated');
            return of(null);
          }
          console.log('[AnonymousAuthenticationPreloader] Start authentication');
          return this.authFirebaseService.signInAnonymously().pipe(
            switchMap((userCredential: UserCredential) =>
              this.authFirebaseService.saveFirebaseTokenInSessionStore$(userCredential),
            ),
            take(1),
            switchMap(() => this.userService.createAnonymousUser$()),
            switchMap(() => this.authFirebaseService.loadUser$()),
            tap(() => console.log('[AnonymousAuthenticationPreloader] Authentication succeeded')),
          );
        }),
      )
      .subscribe();
  }
}
